module.exports = __webpack_public_path__ + "media/theme/zigzag--sp--white_01-52d6be73.png";